import * as Handlebars from "handlebars";
import * as i18n from "i18next";
import "../../common/common-helpers";

Handlebars.registerPartial('socialButtonsFollow', require('../../common/social.buttons.follow.htm'));
Handlebars.registerPartial('socialButtonsShare', require('../../common/social.buttons.share.htm'));

Handlebars.registerHelper('gt', function( a, b, options){
    return (a > b) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('print', function (t) {
    console.info(t);
});
Handlebars.registerHelper('datePH', function () {
    var ldf = i18n.t("$dateformat");
    for (var i = 0; i < ldf.length; i++) {
        if (ldf.charAt(i).match(/[a-z]/i)) {
            ldf = ldf.slice(0, i) + ldf.charAt(i) + ldf.slice(i, ldf.length);
            i++;
        }
    }
    return ldf;
});
Handlebars.registerHelper('getComponentImageSrc', function (cid, index) {
    return `/CampaignCloud/emailoptin/${cid}/getComponentImage/${index}`;
});
Handlebars.registerHelper('urlEncode', function (url) {
    return new Handlebars.SafeString(encodeURIComponent(url));
});
Handlebars.registerHelper('optinUrl', function (userId, campaignId) {
    var host = window.location.hostname;
    return new Handlebars.SafeString('https://'
        + host + "/o/" + campaignId);
});
Handlebars.registerHelper('userSub', function (options) {
    return window.location.hostname.match(/(.+)\.tellody\.com/)[1];
});
Handlebars.registerHelper('extend', function (obj1, obj2, options) {
    return Object.assign(obj1, obj2);
});
Handlebars.registerHelper('alias', function (obj, name, options) {
    var o = {};
    o[name] = obj;
    return o;
});

Handlebars.registerHelper('countryCodeToFlag', function (countrycode) {
    if (countrycode != undefined) {
        return new Handlebars.SafeString("flag-icon flag-icon-" + countrycode.toLowerCase() + "");
    }
});

